const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}


/*======================
    Enavi Custom JS
=======================*/

window.theme = window.theme || {};

theme.EnaviProductForm =(function(){
  
  const selectors = {
    fairPricingTab: '#fair_pricing',
    fairOurPrice: '.fair-lj-price .fair-price', 
    fairTraditionalPrice: '.fair-traditional-price .fair-price',
    descriptionAccordion: 'details .description_accordion',
    styleSelector: '#Style-Selector'
  };

  function EnaviProductForm(container){
    if(container){
      this.init(container);
    }
  };

  EnaviProductForm.prototype = Object.assign({}, EnaviProductForm.prototype, {
    init: function(container){
      this.container = container;
      this.sectionID = this.container.dataset.section;
      this.widthSwatches = this.selectAll(".product-shop-width-swatch");
      this.styleDropdown = document.querySelector(selectors.styleSelector);
      this.currencySymbol = this.container.dataset.currencySymbol?.replace(/\{\{amount\}\}/g, '') || '$';
      this.fairPricingTab = this.select(selectors.fairPricingTab);
      this.fairOurPrice =  this.fairPricingTab.querySelector(selectors.fairOurPrice);
      this.fairTraditionalPrice =  this.fairPricingTab.querySelector(selectors.fairTraditionalPrice);
      this.descriptionAccordion = document.querySelector(selectors.descriptionAccordion);
      if(this.container.classList.contains('product-width-template') || this.container.querySelector('.style-selector')){
        this.initProductFamily(this.widthSwatches);
      }

      document.addEventListener('enavi:variantChange', this.updateElementsOnVariantChange.bind(this));
    },

    initProductFamily: function(widthSwatches) {
      // Handle existing width swatches (buttons)
      widthSwatches.forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          widthSwatches.forEach((sw) => sw.classList.remove('selected'));
          swatch.classList.add('selected');
          this.handleProductChange(swatch.dataset.productHandle);
        });
      });

      // Handle style selector dropdown
      if (this.styleDropdown) {
        this.styleDropdown.addEventListener('change', (e) => {
          const selectedOption = e.target.options[e.target.selectedIndex];
          this.handleProductChange(selectedOption.getAttribute('data-product-handle'));
        });
      }
    },

    handleProductChange: function(productHandle) {
      var option_0, option_1, option_2;
      try {
        option_0 = document.querySelector('[name="options[Color]"]:checked').value;
        option_1 = document.querySelector('[name="options[Material]"]:checked').value;
        option_2 = document.querySelector('[name="options[Length]"]:checked').value;
      } catch(err) {
        document.querySelectorAll('product-selector .product-selector__label').forEach(function(element, index) {
          if(index == 0) {
            option_0 = document.querySelector('[name="options['+element.dataset.productOption+']"]:checked').value;
          }
          if(index == 1) {
            option_1 = document.querySelector('[name="options['+element.dataset.productOption+']"]:checked').value;
          }
          if(index == 2) {
            option_2 = document.querySelector('[name="options['+element.dataset.productOption+']"]:checked').value;
          }
        });
      }
      window.history.replaceState({}, document.title, productHandle);

      fetch(`/products/${productHandle}?section_id=${this.sectionID}`)
        .then((res) => res.text())
        .then((data) => {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = data;
          var get_d = tempDiv.querySelector('section.enavi-product-form').innerHTML;
          document.querySelector('section.enavi-product-form').innerHTML = get_d;
          
          this.styleDropdown = document.querySelector(selectors.styleSelector);
          
          setTimeout(() => {
            try {
              document.querySelector('[name="options[Color]"][value="'+ option_0 + '"]').parentElement.querySelector('label').click();
              document.querySelector('[name="options[Material]"][value="'+ option_1 + '"]').parentElement.querySelector('label').click();
              document.querySelector('[name="options[Length]"][value="'+ option_2.replace(/"/g,'\\"')  + '"]').parentElement.querySelector('label').click();
            } catch(err) {
              document.querySelectorAll('product-selector .product-selector__label').forEach(function(element, index) {
                if(index == 0) {
                  document.querySelector('[name="options['+element.dataset.productOption+']"][value="'+ option_0.replace(/"/g,'\\"') + '"]')?.parentElement.querySelector('label').click();
                }
                if(index == 1) {
                  document.querySelector('[name="options['+element.dataset.productOption+']"][value="'+ option_1.replace(/"/g,'\\"') + '"]')?.parentElement.querySelector('label').click();
                }
                if(index == 2) {
                  document.querySelector('[name="options['+element.dataset.productOption+']"][value="'+ option_2.replace(/"/g,'\\"') + '"]')?.parentElement.querySelector('label').click();
                }
              });
            }
          }, 1000);

          //Refresh Affirm UI
          try {
            affirm.ui.refresh();
          } catch (error) {
            console.log(error);
          }

          this.fairPricingTab = document.querySelector(selectors.fairPricingTab);
          this.fairOurPrice = this.fairPricingTab.querySelector(selectors.fairOurPrice);
          this.fairTraditionalPrice = this.fairPricingTab.querySelector(selectors.fairTraditionalPrice);
          document.querySelector('#defaultOpen')?.click();

          var productDescription = document.querySelector('.main-product__tab-content.product-description_tab');
          if(this.descriptionAccordion && productDescription){
            this.descriptionAccordion.innerHTML = productDescription.innerHTML;
          }

          var newWidthSwatches = document.querySelector('section.enavi-product-form').querySelectorAll('.product-shop-width-swatch');
          return newWidthSwatches;
        })
        .then((widthSwatches) => {
          this.initProductFamily(widthSwatches);
          //Sync review section
          var reviewSection = document.querySelector('#judgeme_product_reviews').closest('.shopify-section');
          if(reviewSection){
            var reviewSectionId = reviewSection.id.replace('shopify-section-','');
            fetch(`/products/${productHandle}?section_id=${reviewSectionId}`).then(
              res => res.text()).then((html) => { 
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");

                reviewSection.innerHTML = doc.querySelector('.shopify-section').innerHTML;
                const jdgmScript = document.querySelector('script[src="https://cdn.judge.me/loader.js"]');
                if(jdgmScript){
                  jdgmScript.remove();
                }
                const jdgmLoader = document.createElement('script');
                jdgmLoader.src = 'https://cdn.judge.me/loader.js';
                document.head.appendChild(jdgmLoader);
            });
          }
        });
    },

    updateVariantWeight: function(evt){
      var weightDataEl = document.querySelector('[data-product-weight-json]');
      if(!weightDataEl){
        return;
      }
      var jsonWeightData = JSON.parse(weightDataEl.innerHTML);
      var weightLineItem = document.querySelector('#est-weight');
      var variantId = evt.detail.variant.id;

      jsonWeightData['variant_weight'].forEach(function(variant) {
        if (variant['id'] == variantId) {
          var variantWeightChange = document.querySelector(".variant_weight_change");
          var variantWeightElement = variantWeightChange.closest('.variant_weight');
          variantWeightElement.style.display = 'block';

          if (variant.weight == 0) {
            variantWeightElement.style.display = 'none';
          } else if (variant.weight % 1 == 0) {
            variantWeightChange.textContent = variant.weight.toFixed(1);
          } else {
            variantWeightChange.textContent = variant.weight;
          }

          if (weightLineItem && variant.weight != 0) {
            if (variant.weight % 1 == 0) {
              weightLineItem.value = variant.weight.toFixed(1) + ' grams';
            } else {
              weightLineItem.value = variant.weight + ' grams';
            }
          }
        }
      });
    },

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    updateElementsOnVariantChange: function(evt) {
      this.updateVariantWeight(evt);
      this.updateEstCompletion(evt);
      this.updateFairPricing(evt);
    },

    updateEstCompletion: function(event) {

      var estCompletionEl = document.querySelector('.variant_completion');

      try{
        var optionWidth = document.querySelector('.product-shop-width-swatch.is-active:not(.style-product)').dataset.productFamilyMemberTitle;
      }
      catch(err){
        var optionWidthEl = document.querySelector('[name="options[Width]"]:checked');
        if(!optionWidthEl){
          optionWidthEl = document.querySelector('[name="options[Width (millimeter)]"]:checked');
        }
        if(optionWidthEl){
          optionWidth = optionWidthEl.value;
        }
      }

      if (!estCompletionEl || !optionWidth) {
        return;
      }

      var completionDays = parseInt(estCompletionEl.dataset.estDays) || 18;
      var estDate = estCompletionEl.querySelector('.variant_completion_change');
      estCompletionEl.style.display = 'block';

      var currentVariant = event.detail.variant;
      var productWidth = parseInt(optionWidth.replace(/\D+/g, ''));
      var productPrice = parseInt(currentVariant.price);
      var productAvailable = currentVariant.available;

      if(productWidth>=7){
        estDate.innerText = 'Handmade to order - estimated completion date: '+ 
          new Date(new Date().getTime()+(completionDays*24*60*60*1000)).toLocaleDateString("en-US", 
          { month: 'short', day: 'numeric' });
      }else if(productAvailable == true){  
        if(productPrice < 10000){
          estDate.innerText = 'In stock with free shipping over $100'
        }else{
          estDate.innerText = 'In stock with free shipping'
        }
      }else{
        estCompletionEl.style.display = 'none';
      }
    },

    updateFairPricing: function(event) {
      if(!this.fairPricingTab){
        return;
      }
      var variantPrice = (parseFloat(event.detail.variant.price) / 100);
      var markupPercentage = parseFloat(this.fairPricingTab.dataset.markup);
      var fairTraditionalPrice = (variantPrice * (markupPercentage / 100));
      
      this.fairOurPrice.innerText = this.currencySymbol + variantPrice.toFixed(2);
      this.fairTraditionalPrice.innerText = this.currencySymbol + fairTraditionalPrice.toFixed(2);
    }

  });

  return EnaviProductForm;
})();

new theme.EnaviProductForm(document.querySelector('.enavi-product-form'));